/**
 * @generated SignedSource<<7c9ffd8014a50e790f821847f954e9d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyCodeStepNotifications_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly name: string;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "VerifyCodeStepNotifications_session";
};
export type VerifyCodeStepNotifications_session$key = {
  readonly " $data"?: VerifyCodeStepNotifications_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"VerifyCodeStepNotifications_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VerifyCodeStepNotifications_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "007e2a588f1ce5d2a7fd05c65dd4686e";

export default node;
